import React from 'react';
import { observer } from 'mobx-react';
import { FormattedMessage, useIntl } from 'react-intl';
import { hasPermission } from '../../../infrastructure/utils/has-permissions';
import { Permission } from '../../../api/roles.dao';
import DefaultButton from '../../global/default-button/default-button';
import { BlueprintsNavigation } from '../shared/blueprints-navigation';
import { ITheadSort, ListLayout } from '../../global/tables/table-list-layout';
import { TGetReportsSortKeys } from '../../../api/reports.dao';
import TableLoadingRow from '../../global/tables/table-loading-row';
import { DESCRIPTION } from '../../../constants/common-labels.constants';
import { OrderTemplatesVM } from './order-templates.viewmodel';
import { OrderTemplatesListItem } from './order-templates-list-item/order-templates-list-item';
import {
    CREATE_ORDER_TEMPLATE_BUTTON_TEXT,
    NO_ORDER_TEMPLATES_TEXT,
    ORDER_TEMPLATE_TABLE_DATE_CREATED_TEXT,
    ORDER_TEMPLATE_TABLE_DATE_MODIFIED_TEXT,
    ORDER_TEMPLATE_TABLE_NAME_TEXT
} from './order-templates.texts';

type Props = {
    vm: OrderTemplatesVM;
};

export const OrderTemplatesPresentation = observer((props: Props): JSX.Element => {
    const intl = useIntl();

    const { vm } = props;

    const isListEmpty = !vm.isLoading && !vm.orderTemplates.length;

    const tHeads: ITheadSort<TGetReportsSortKeys>[] = [
        { title: intl.formatMessage(ORDER_TEMPLATE_TABLE_NAME_TEXT) },
        { title: intl.formatMessage(ORDER_TEMPLATE_TABLE_DATE_CREATED_TEXT) },
        { title: intl.formatMessage(ORDER_TEMPLATE_TABLE_DATE_MODIFIED_TEXT) },
        { title: intl.formatMessage(DESCRIPTION) },
    ];

    return (
        <div className='event-blueprints'>
            <section className='horizontal-row horizontal-row--with-bottom-margin event-tabs'>
                <BlueprintsNavigation />
                <div className='horizontal-row__align-to-row-end'>
                    <div className='buttons-block'>
                        {hasPermission(Permission.CREATE_ORDER_TEMPLATE) &&
                            <DefaultButton
                                modifier={['fat', 'confirm-safe']}
                                text={intl.formatMessage(CREATE_ORDER_TEMPLATE_BUTTON_TEXT)}
                                dataTestId='create-order-template'
                                onClick={vm.openCreateTemplateForm.bind(vm)}
                            />
                        }
                    </div>
                </div>
            </section>
            <section className='fixed-list-layout'>
                <div>
                    <ListLayout sortOptions={{ theads: tHeads }}>
                        {vm.isLoading && <TableLoadingRow colSpan={tHeads.length} />}
                        {isListEmpty &&
                            <tr>
                                <td className='table-loading' colSpan={tHeads.length}>
                                    <FormattedMessage {...NO_ORDER_TEMPLATES_TEXT} />
                                </td>
                            </tr>
                        }
                        {!vm.isLoading && vm.orderTemplates.map(item => {
                            return <OrderTemplatesListItem
                                key={item.blueprintId}
                                item={item}
                            />;
                        })}
                    </ListLayout>
                </div>
            </section>
        </div>
    );
});
